<script setup>
import initCore from '@core/initCore'
import {
  initConfigStore,
  useConfigStore,
} from '@core/stores/config'
import { hexToRgb } from '@layouts/utils'
import { useTheme } from 'vuetify'
import { VSonner } from 'vuetify-sonner'
import { isPwaEnabled } from '@/plugins/2.router/public-routes'

const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()

const route = useRoute()

// ^ Set PWA manifest according to routes
const updateManifestLink = () => {
  // Find the manifest link
  const manifestLink = document.querySelector('link[rel="manifest"]')
      
  if (manifestLink) {
    if (!isPwaEnabled(window.location.pathname)) {
      manifestLink.setAttribute('href', '') // Set href to empty
    } else {
      manifestLink.setAttribute('href', '/manifest.webmanifest') // Set href to manifest
    }
  }
}

watch(() => route.path, () => {
  updateManifestLink()
})

onMounted(() => {
  updateManifestLink()
})
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />
      <VSonner position="top-center" />
    </VApp>
  </VLocaleProvider>
</template>
